// extracted by mini-css-extract-plugin
export default {"subcategoriesRow":"k_6","subcategoryColumn":"k_7","articleLink":"k_8","articleCoverImage":"k_9","articleTitle":"k_bb"};